<div
  class="file-upload-container"
  *ngIf="{ dragging: dragging$ | async } as fileUpload"
>
  <div
    class="file-upload-body"
    [ngClass]="{ dragover: fileUpload.dragging }"
    (click)="openFilePicker()"
    (drop)="dataDropped($event)"
    (dragover)="dragover($event)"
    (dragleave)="dragleave()"
  >
    <div class="file-upload-icon mb-3">
      <icon set="lucide" size="28" name="upload" />
    </div>
    <div>
      <span class="file-upload-body-header">
        {{
          "IDE.UPLOAD.UPLOAD_FILE_" + (maxFiles > 1 ? "MULTIPLE" : "SINGLE")
            | translate
        }}
      </span>
      <span
        *ngIf="extensions.length"
        class="file-upload-body-header--extensions d-block mt-4"
      >
        {{ extensions | formatExtensions: { space: true } }}
      </span>
      <span class="file-upload-body-header--extensions d-block mt-4">
        {{
          "IDE.UPLOAD.MAX_FILE_SIZE"
            | translate: { maxFileSize: maxTotalSize ?? maxFileSize | fileSize }
        }}
      </span>
    </div>
    <div
      class="file-upload-overlay"
      [class.file-upload-overlay--active]="fileUpload.dragging"
    ></div>
  </div>

  <ng-container *ngIf="customFileListTemplateRef; else defaultTemplate">
    <ng-container
      [ngTemplateOutlet]="customFileListTemplateRef"
      [ngTemplateOutletContext]="{
        files,
        removeFile: allowCustomRemove
          ? removeFileFromCustomTemplate.bind(this)
          : null
      }"
    />
  </ng-container>

  <ng-template #defaultTemplate>
    <div class="file-list-body" *ngIf="files.length">
      <h3 class="file-list-header color-hwhite">
        {{ "IDE.UPLOAD.ADDED_FILES" | translate }}
      </h3>
      <ul class="file-list">
        <li class="file-list-element" *ngFor="let file of files; let i = index">
          <span>
            {{ file.filename }}
          </span>
          <icon
            class="file-delete-icon"
            set="lucide"
            name="trash"
            (click)="
              removeFile(i);
              filesAmountExceeded = false;
              filesTotalSizeExceeded = false
            "
          ></icon>
        </li>
      </ul>
    </div>
  </ng-template>

  <div class="invalid-file-list mt-4" *ngIf="filesAmountExceeded">
    <validation-message>
      {{ "IDE.UPLOAD.FILE_AMOUNT" | translate: { maxFiles: maxFiles } }}
    </validation-message>
  </div>

  <div class="invalid-file-list mt-4" *ngIf="filesTotalSizeExceeded">
    <validation-message>
      {{
        "IDE.UPLOAD.TOTAL_FILE_SIZE"
          | translate: { maxTotalSize: maxTotalSize | fileSize }
      }}
    </validation-message>
  </div>

  <div
    class="invalid-file-list invalid-file-list--validation"
    *ngIf="invalidFileList.length"
  >
    <validation-message
      [customTemplate]="validatorTemplate"
    ></validation-message>
  </div>
</div>

<input
  class="file-picker"
  type="file"
  accept="{{ extensions | formatExtensions }}"
  [multiple]="maxFiles > 1"
  (change)="getFiles($event)"
  #filePicker
/>

<ng-template #validatorTemplate>
  <ul class="invalid-file-list__items">
    <li
      class="invalid-file-list__item"
      *ngFor="let file of invalidFileList; let i = index"
    >
      <span class="invalid-file-list__text">
        <b>{{ file.name }}</b>
        :
        {{ file.reason | translate: { maxFileSize: maxFileSize | fileSize } }}
      </span>
    </li>
  </ul>
</ng-template>
